import gql from "graphql-tag";

export const CancelAppointment = gql`
  mutation CancelAppointment($ProfileId: ID!, $AppointmentId: ID!) {
    CancelAppointment(
      Input: { AppointmentId: $AppointmentId, ProfileId: $ProfileId }
    )
  }
`;
